import axiosInstance from "../../../../shared/api/axiosInstance.js";
import { baseUrl, DELETE_FEILD_VALUE, EDIT_FEILD_VALUE, CREATE_FEILD_VALUE } from "../../../../shared/api/endpoints.js";
import { configReq } from "../../../../shared/lib/functions.js";
/** Keeps the existing DELETE request and response contract. */
export function deleteFeildValue(data, token) {
  return axiosInstance.delete(`${baseUrl}/${DELETE_FEILD_VALUE}?id=${data.id}`, configReq(token));
}

/** Keeps the existing PUT request and response contract. */
export function editFeildValue(formData, token) {
  return axiosInstance.put(`${baseUrl}/${EDIT_FEILD_VALUE}`, formData, configReq(token, true));
}

/** Keeps the existing POST request and response contract. */
export function createFeildValue(formData, token) {
  return axiosInstance.post(`${baseUrl}/${CREATE_FEILD_VALUE}`, formData, configReq(token));
}
